import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=cad5eb62&scoped=true&lang=pug&"
import script from "./FooterMain.vue?vue&type=script&lang=js&"
export * from "./FooterMain.vue?vue&type=script&lang=js&"
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=cad5eb62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad5eb62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cad5eb62')) {
      api.createRecord('cad5eb62', component.options)
    } else {
      api.reload('cad5eb62', component.options)
    }
    module.hot.accept("./FooterMain.vue?vue&type=template&id=cad5eb62&scoped=true&lang=pug&", function () {
      api.rerender('cad5eb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/footer/FooterMain.vue"
export default component.exports